import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import React, { useState } from "react";
import { Button, View } from "../components/index.js";
import { getTraits } from "../logic/createMonsters.js";
import { findTraits } from "../logic/Logic.js";

const MonsterTable = ({ monsters, onRemoveMonster }) => {
  const traitsFinal = getTraits({ monsters });
  const [extraTextMonster, setExtraTextMonster] = useState(null);

  const getTraitDescription = (traitName) => {
    const trait = findTraits(traitName);
    return trait.length > 0 ? trait[0].description : "";
  };

  return (
    <View marginLateral={15} showBack={false} titulo={"Play"}>
      <style></style>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Threat Level</th>
            <th>Creature</th>
            <th>Mov</th>
            <th>Fight</th>
            <th>Shoot</th>
            <th>Armour</th>
            <th>Will</th>
            <th>Health</th>
            <th>Gold Drop Treasure %</th>
            <th>Traits</th>
            <th>Group</th>
            <th>Position</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {monsters?.map((obj) => {
            return (
              <tr key={obj.uniqueId}>
                <td>{obj.Threat_level}</td>
                <td>{obj.Creature}</td>
                <td>{obj.Mov}</td>
                <td>{obj.Fight}</td>
                <td>{obj.Shoot}</td>
                <td>{obj.Armour}</td>
                <td>{obj.Will}</td>
                <td>{obj.Health}</td>
                <td>{obj["GoldDrop_Treasure%"]}</td>
                <td>
                  {obj.Traits.split(",").map((trait, index) => (
                    <Tooltip
                      key={index}
                      title={getTraitDescription(trait.trim())}
                      arrow
                      slotProps={{
                        tooltip: {
                          sx: { fontSize: "1rem" },
                        },
                      }}
                    >
                      <span>{trait}</span>,
                    </Tooltip>
                  ))}
                </td>
                <td>{obj.group}</td>
                <td>{obj.position}</td>
                <td style={{ display: "flex", gap: 4 }}>
                  {obj.ExtraText && (
                    <Button sx={{ height: 30 }} onPress={() => setExtraTextMonster(obj)} text={"Info"} />
                  )}
                  <Button sx={{ maxWidth: 10, height: 30 }} onPress={() => onRemoveMonster(obj)} text={"-"} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <br></br>
      {traitsFinal.map((obj) => {
        return (
          <div>
            <label style={{ fontWeight: 900 }}>{obj.name}: </label>
            {obj.description}
            <br></br>
            <br></br>
          </div>
        );
      })}
      <Dialog open={!!extraTextMonster} onClose={() => setExtraTextMonster(null)} maxWidth="sm" fullWidth>
        <DialogTitle>{extraTextMonster?.Creature}</DialogTitle>
        <DialogContent>
          <p style={{ whiteSpace: "pre-wrap" }}>{extraTextMonster?.ExtraText}</p>
        </DialogContent>
        <DialogActions>
          <Button onPress={() => setExtraTextMonster(null)} text={"Close"} />
        </DialogActions>
      </Dialog>
    </View>
  );
};

export default MonsterTable;
